var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"green","dark":"","fab":"","href":"/","fixed":"","right":"","bottom":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-restart")])],1)]}}])},[_c('span',[_vm._v("重新开始")])])}
var staticRenderFns = []

export { render, staticRenderFns }